module.exports = __webpack_public_path__ + "img/tui.4b11d852.png";